// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.ghost {\r\n  opacity: 0.8;\r\n  background: #c8ebfb;\n}\n.sortable-ghost {\r\n  background: #c8ebfb !important;\n}\n#myKanban {\r\n  width: -webkit-max-content;\r\n  width: -moz-max-content;\r\n  width: max-content;\n}\r\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
